import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Fire a Lead event (call on form submit success)
export const trackLead = (data = {}) => {
  if (typeof window !== 'undefined' && window.fbq && window.__fbPixelReady) {
    window.fbq('track', 'Lead', data);
  }
};

const FacebookPixel = () => {
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/settings`)
      .then((res) => res.json())
      .then((data) => {
        const pixelId = data && data.facebook_pixel_id;
        if (!cancelled && pixelId && window.fbq && !initialized.current) {
          window.fbq('init', pixelId);
          window.fbq('track', 'PageView');
          window.__fbPixelReady = true;
          initialized.current = true;
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // Track PageView on route change (after init)
  useEffect(() => {
    if (initialized.current && window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);

  return null;
};

export default FacebookPixel;
